import React from 'react'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'


function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Fee Refund Guidelines" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>



                            < Col md={12} className='c-left c-lineheight2dot5 text-dark'>
                                <h3 className='c-headline mb-3'>Fee Refund Guidelines</h3>
                                <p className='text-orange fw-bold fst-italic'>The fee refund guidelines in case of the fees paid to the counselling bodies viz. JoSAA (B.Tech), COAP (M.Tech) and JOAPS (M.Sc) shall be as per the business rules of the respective counselling bodies. For the fee amounts directly paid to IIT Tirupati, the following guidelines for fee refund under various circumstances are issued herewith. </p>

                                <h3 className='c-headline mt-5 mb-3'>Case 1: Refund of fee for withdrawal of admission before the commencement of classes</h3>
                                <p>Whenever a student who secures admission in IIT Tirupati chooses to withdraw before the commencement of classes or within One week (7 days) from the date of orientation, whichever is earlier, the student will receive the refund of full fee paid after a deduction of Rs.3,000/- as processing fee. Fee amounts received from the respective counselling bodies are non-refundable and hence in such cases the processing fee shall be waived off subject to a maximum limit of Rs.3,000/- or the fee amount received from the respective counselling body, whichever is minimum. </p>


                                <h3 className='c-headline mt-5 mb-3'>Case 2: Refund of fee for withdrawal of admission after the commencement of classes</h3>
                                <p>Whenever a student who secures admission in IIT Tirupati chooses to withdraw after the commencement of classes, the student will receive only the refund of caution deposits (Institute, Library & Hostel) subject to ‘no dues”. The same guidelines apply to graduating students also.  </p>


                                <h3 className='c-headline mt-5 mb-3'>Case 3: Refund of excess fee paid due to various reasons</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><span className="fw-bold">Bank Loan</span> – There are cases where the bank pays the fee and the students also pay the fee to avoid delay. In such cases, the excess fee will be refunded to the student upon a request made to Academic Section.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><span className="fw-bold">Income Certificate</span> – There are cases where students pay the fee in a higher income category due to the non-availability of proper income certificate. In such cases, the excess fee will be refunded to eligible students upon submission of a proper income certificate within the same academic year. Refund claims of current academic year shall only be processed.</li>
                                </ul>


                                <h3 className='c-headline mt-5 mb-3'>General guidelines:</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Proper Income Certificate would mean a family income certificate issued by the competent revenue authority of the concerned state government of the state where the student originally domiciles.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />The fee refunds will be made through online mode only. </li>
                                </ul>

                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;